import React, { useState, useEffect } from "react";
import { lazy } from 'react';
import { Overview } from "@/views/Agenda/Overview";
import EventItem from '@/views/Agenda/EventItem'
import DossierItem from '@/views/Agenda/DossierItem'
import ScheduleDossierItem from "./ScheduleDossierItem";
import ScheduleCalender from "./ScheduleCalender";
import store from "@/redux/store";
import {setItemForSchedule, createTaskForScheduleItem, getUserSchedules} from '@/reducers/CommunicationCycle';

import moment from 'moment';
import CalenderHelperClass from '@/helpers/CalenderHelper'
import {TaskScheduleModel} from '@/models/TaskSchedule';

import { PPCTimeField } from "@/components/datetime/PPCTimeField";

import { TrashIcon,ClockIcon, CogIcon, UserGroupIcon } from '@heroicons/react/16/solid'

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'

import { updateScheduleItems, createScheduleItem, setSelectedTask,deleteUserTask } from '@/reducers/Schedule'
import {show, hide, MODAL_TYPE} from '@/reducers/ModalReducer';
import RemoveUserTaskItem from '@/components/timeline/view/modals/view/RemoveUserTaskItem';
import DB from "@/models/DB";
//    const RemoveUserTaskItem = import('@/components/timeline/view/modals/view/RemoveUserTaskItem');
import PlanViewGroup from './planviews/Group';

export function PlanView({...props}) {
    
    let selectedTask = null;
    const [scheduleItems, setScheduleItems] = useState(null);
    const [currentDate, setCurrentDate] = useState(((props?.selectedDate) ? props.selectedDate : moment()));
    
    const [taskSchedule, setTaskSchedule] = useState(((props.dossierScheduleItems ) ? props.dossierScheduleItems : {}));
    //let taskSchedule = props.dossierScheduleItems;
        
    let days = CalenderHelperClass.getDaysForSchedule(currentDate);
    /*
    
    console.info("dossierScheduleItems", props?.dossierScheduleItems);
    let f1 = props?.dossierScheduleItems.first();
    let users12 = DB.newCollection(f1.users);
    console.info("user collection", users12);
    let firstU = users12.first();
    firstU["20250401"].duration = 1;
    //f1.users = users12.get(); 
    //users12.delete(firstU.uid);
    //props?.dossierScheduleItems.update(f1.uid, )
    
    console.info("dossierScheduleItems", users12 );
    console.info("dossierScheduleItems", firstU );
    console.info("dossierScheduleItems", users12.first() );
    */
useEffect(() => {
    console.debug( "props?.selectedTask", props?.selectedTask )
    selectedTask = props?.selectedTask;
}, [selectedTask, props?.selectedTask]);    
//    const { t, i18n, ready } = useTranslation();


const onEventItemClickEvent = (event, day) => {
    
    store.dispatch( createTaskForScheduleItem({}) );
//createTaskForScheduleItem
}

const setTaskForDayEventHandler= (event, task, user, day) => {
        store.dispatch( createScheduleItem({dossier:props?.dossier,task, user, day}) );
return false;
   let taskKey = task.key;
   let taskScheduleModel;
   if(taskSchedule && taskSchedule[taskKey]) {
      taskScheduleModel = taskSchedule[taskKey];
      taskScheduleModel.addUserTask({userKey: user.key, taskKey: task.key, day: day}); 
   } else {
       taskScheduleModel = new TaskScheduleModel({userKey: user.key, taskKey: task.key, day: day});
       
   }
    
setTaskSchedule({
  ...taskSchedule, // Copy the old fields
  [taskKey]: taskScheduleModel // But override this one
});   
   setScheduleItems({
       ...scheduleItems,
       [user.key]: taskScheduleModel.getUserForKey(user.key)
   })
   //taskSchedule.push( taskScheduleModel );
   
   return false; 
   }

const removeEventHandler = ((event, item) => {
    console.debug("VERWIJDER", event)
    console.debug("VERWIJDER", item)
    //let newItem = {...item, state: 9};
    props.dossierScheduleItems.delete( item.uid );
    
    //store.dispatch( deleteUserTask({userTask: newItem, taskScheduleModel: props?.selectedTask }) );
    store.dispatch( hide(null) );
    store.dispatch( deleteUserTask(null) );
});

const removeUserScheduleItemEvent = (event, item, userTask) => {
    
    
    store.dispatch( show({modalType: MODAL_TYPE.REMOVE_USERTASKITEM, data: userTask, options: {
        body: (<RemoveUserTaskItem  succesEventHandler={removeEventHandler} data={userTask} userTaskUID={userTask.uid}/>)
        
    } }) );
}



const setSelectedTaskEventHandler= (event, task) => {
    if(props?.selectedTask && props?.selectedTask['key'] == task['key']) {
        store.dispatch( setSelectedTask({selectedTask: null}) );
    } else {
        store.dispatch( setSelectedTask({selectedTask: task}) );
   }
   
   return false; 
   }

const onUserSelectHandler = (data) => {
    
    store.dispatch( getUserSchedules(data) );
return;    
    //store.dispatch( createTaskForScheduleItem({}) );
    return false;
//createTaskForScheduleItem
}

const setValue = (name, time, userTask, taskSceduleItem) => {
    userTask.workhours = time;
    
    }

const createTaskView = (taskSceduleItem, rowStartTask, selectedTask, scheduleTaskItems) => {
                    if(!selectedTask || !scheduleTaskItems || (scheduleTaskItems && scheduleTaskItems.length == 0)) return (<>
            <div className={"col-start-2 row-start-"+rowStartTask+" border-r "} style={{gridColumn: `span 42 / span 42`}}>

            </div>
                    
                    </>);
                    
     let firstTask = scheduleTaskItems.first();
     let lastTask = scheduleTaskItems.last();
    
    
    let startCol = (days[firstTask.dayKey]).index + 2;
    let endCol = ((days[lastTask.dayKey]).index + 2)+1;
//    let taskData = scheduleItems[taskSceduleItem?.taskKey];
//     console.debug("taskSceduleItemtaskSceduleItem",selectedTask)
//rowStartTask = rowStartTask+1;
    return (
            <div className={"p-1 row-start-"+rowStartTask+" sticky z-30  overflow-hidden "} style={{gridColumnStart: startCol, gridColumnEnd: endCol}}>
            <div className="rounded-lg border border-blue-700/10 bg-blue-400/20 px-1 dark:border-sky-500 dark:bg-sky-600/50 overflow-hidden ">
            <span className="truncate pr5 block width-inherit text-sm text-sm/6 h-[80%]">
                {selectedTask.name}
            </span>
            </div>
            </div>
        
    )
    
    
}

const createUserTaskView = (taskSceduleItem, item, user, day, rowStartTask, userScheduledTasks) => {
    
    
    
    let startCol = day.index + 2;
    let endCol = (day.index + 2)+1;
     
     let workhours = 0;
     let userTask = userScheduledTasks.first();
     let dayItem = userTask.dayKey;
     if(userTask['workhours']) {
         workhours = userTask['workhours'];
     }
    return (
            <div key={userTask.uid} className={"w-full border-r border-gray-100 row-start-"+rowStartTask+" sticky z-30  overflow-hidden"} style={{gridColumnStart: startCol, gridColumnEnd: endCol}} draggable={true}>
            <div className="w-[95%] mx-1 rounded-lg border border-blue-700/10 bg-blue-400/20 px-1 dark:border-sky-500 dark:bg-sky-600/50 overflow-hidden grid grid-cols-6 gap-1">
            <span className="truncate pr-2 block width-inherit text-sm text-sm/6 h-[90%] col-span-4" >
                <PPCTimeField key={userTask.uid} autoFocus onChange={(name, time) => {setValue(name, time, userTask, item);}} name="workhours"  hourCycle={24} defaultValue={workhours}/>  
            </span>

<div className="col-span-2 flex">
<button type="button" className="rounded-full col-span-2"><TrashIcon aria-hidden="true" className="size-5" onClick={(event) => {removeUserScheduleItemEvent(event, dayItem, userTask)}} /></button>
<button type="button" className="rounded-full col-span-2"><CogIcon aria-hidden="true" className="size-5" /></button>            
</div>
            </div>
            </div>
            
         
        
    )
    
    
}

const createTaskOverView = (dossier) => {
    let taskView = [];
    
                {props?.dossier && props?.dossier?.children && props?.dossier?.children.get().map((item, taskIndex) => {
                rowStartTask = (taskIndex+2)+rowStartUser;
                    taskView.push( (<PlanViewGroup key={item.uid} item={item} rowStartTask={rowStartTask} />) );
                })}

    return taskView;
    
}



      

     let users = props?.users
 let totalDays = days.length + 1;
 let tasks = props?.tasks;
 
 if(!users || !tasks) {
     return (<></>);
 }
 
 let rowStartTask = 2;
 let rowStartUser = 0;
 
 let totalRows = Object.keys(users).length + Object.keys(tasks?.children).length; 
    //const {selectedTask} = props;
    
    let selectedScheduleTask = null;
    if(props?.selectedTask && props?.selectedTask?.key && props.dossierScheduleItems) {
        selectedScheduleTask = props.dossierScheduleItems.where('taskKey', props?.selectedTask?.key).get(true);
    }
        return (
        <>

        
        
        <div className="overflow-hidden dark:bg-gray-800">
        <div className={"grid max-h-90 grid-cols-[320px_repeat("+(totalDays)+",200px)] grid-rows-[auto_repeat("+totalRows+",50px)] overflow-scroll"}>
            <div className="sticky top-0 left-100 z-20 col-start-1 row-start-1 border-b bg-white-900  border-gray-100 bg-white bg-clip-padding py-2 text-sm font-medium text-gray-900 dark:border-black/10 dark:bg-gradient-to-b dark:from-gray-600 dark:to-gray-700 dark:text-gray-200 "></div>
            
            {days && Object.keys(days).map((dayKey, mindex) => {
                let day = days[dayKey];
            
            return (
                <div className={"sticky top-0 z-10 w-32 col-start-"+(mindex+2)+" row-start-1 border-b border-gray-100 bg-white bg-clip-padding py-2 text-center text-sm text-black-900"}>{day['day']}</div>
                );
            })}
 
            {createTaskOverView(props?.dossier)}
        </div>
        

        
        
        </div>
        </>
    )

}


/*
           
    {tasks && tasks.children && Object.keys(tasks.children).map((itemKey, taskIndex) => {
        let item = {...tasks.children[itemKey]};
        let scheduleTaskItems = (!props.dossierScheduleItems)? null : props.dossierScheduleItems.where('taskKey', item.key).get(true)

        item.isOwner = true;
        rowStartTask = (taskIndex+2)+rowStartUser;
        
        let taskSceduleItem = null;
        let workhours = 0;
        let userKeys = null;
        if(taskSchedule && taskSchedule[ item['key']]) {
            taskSceduleItem = taskSchedule[ item['key']]
            userKeys = Object.keys(taskSceduleItem.users);
            //if(taskSceduleItem['users'] && taskSceduleItem['users'][user.key][day.daykey]['workhours']) {
            if(taskSceduleItem['duration']) {
                workhours = taskSceduleItem['duration'];
            }
            if(item['duration']) {
                workhours = item['duration'];
                }
                
        }
        
                return (
                    <>
            <div className={"sticky z-50 w-72 left-0 col-start-1 row-start-"+rowStartTask+" border-r border-gray-100 bg-white p-1.5 text-left text-xs font-medium text-gray-400 uppercase dark:border-gray-200/5 dark:bg-gray-800 grid grid-cols-7 gap-1"}>
            <span className="col-span-1">
            <button type="button" 
            onClick={(event) => {setSelectedTaskEventHandler(event, item)}}
            className="inline-flex items-center gap-x-1 rounded-md bg-indigo-600 px-1.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"><UserGroupIcon aria-hidden="true" className="size-5" /></button>
            </span>
            <span className="col-span-4 inline-flex items-center">
            {item.name}
            </span>
            <span className="col-end-7 align-center items-center justify-items-center text-center"><ClockIcon className="size-4 w-full flex" /><span className="duration" data-duration={item?.key}>{item?.duration}</span></span>  
            </div>
            
             
                {createTaskView(taskSceduleItem, rowStartTask, item, scheduleTaskItems)}
            
            
            
            
            <>
            
            {selectedScheduleTask && props?.selectedTask && props?.selectedTask?.key == item?.key && Object.keys(users).map((userKey, userIndex) => {
                let user = users[userKey];
                let userScheduledTasks = selectedScheduleTask.where('userKey', user.key).get(true);
                rowStartUser = (userIndex+1)+rowStartTask;
                return (
                    <>
            <div className={"sticky z-50  left-0 col-start-1 row-start-"+rowStartUser+" border-r border-gray-100 bg-white p-1.5 text-left pl-10 text-xs font-medium text-gray-400 uppercase dark:border-gray-200/5 dark:bg-gray-800"}>
            {user.first_name}
            </div>
            {days && Object.keys(days).map((dayKey, mindex) => {
                let day = days[dayKey];
                let userDayScheduledTasks = userScheduledTasks.where('dayKey', day.daykey).get(true);
                if(userDayScheduledTasks.length > 0) {
                    return createUserTaskView(taskSceduleItem, item, user, day, rowStartUser, userDayScheduledTasks);
                }
            return (
            <div className={"col-start-"+(mindex+2)+" row-start-"+rowStartUser+" border-r border-b border-gray-100 dark:border-gray-200/5"}
            onClick={(event) => {setTaskForDayEventHandler(event, item, user, day)}}
            >
            </div>
                )
            })}
            </>
            )})}
            </>

            </>
            )})}
*/